module.exports = "/images/lt.svg?1ac85baa5eda6b5172398c8981322ae3";